import StateMachine from 'javascript-state-machine';
import StateMachineHistory from 'javascript-state-machine/lib/history';

const trackingIds = {
  test: 'UA-26150035-4',
  wolf: 'UA-26150035-8',
  phoenix: 'UA-26150035-23',
};

const useProdTracking = /ifit.com/.test(window.location.origin);

export default class BaseNavigator {
  initStateMachine(initialPage, transitions, appName) {
    transitions = [...transitions,
      { name: 'jumpTo', from: '*', to: page => page },
    ];

    this.validateTransitions(transitions);

    this.stateMachine = new StateMachine({
      init: initialPage,
      transitions,
      plugins: [new StateMachineHistory()],
      methods: {
        onTransition: function(lifecycle) {
          const trackingId = useProdTracking ? trackingIds[appName] : trackingIds.test;
          if (window && window.gtag) {
            window.gtag('config', trackingId, {
              'page_title': lifecycle.to,
              'page_path': `/${appName}/${lifecycle.to}`
            });
          }
        }
      },
    });
  }

  validateTransitions(transitions) {
    transitions.forEach((transition) => {
      ['from', 'to'].forEach((key) => {
        if (!transition[key]) throw new Error(`The following transition has an invalid "${key}" property: ${JSON.stringify(transition)}`);
      });
    });
  }

  forward(appState = {}, next = () => {}) {
    return this.stateMachine.next(appState, next);
  }

  backward(appState = {}, next = () => {}) {
    try {
      // first try the state machine back function (for profile/fitness plan settings on phoenix)
      return this.stateMachine.previous(appState, next);
    } catch (err) {
      // fall back to browser history, if available
      if (this.stateMachine.history.length > 1) {
        return this.stateMachine.historyBack();
      }
    }
  }

  jumpTo(page) {
    return this.stateMachine.jumpTo(page);
  }

  getCurrentPage() {
    return this.stateMachine.state;
  }
}
